export const FEEDBACK_MODAL_ZINDEX = 1050;
export const FEEDBACK_MODAL_SELECT_ZINDEX = FEEDBACK_MODAL_ZINDEX + 1;
